import { Injectable, NgZone, signal, WritableSignal } from '@angular/core';
import { JoinEvent } from '@core/models/zoom.models';
import { ZoomMtg } from '@zoom/meetingsdk';
import { BookingEventService } from '@core/services/api/booking-event.service';
import { Router } from '@angular/router';

export const zoomStart = 'zoomStart';
@Injectable({
  providedIn: 'root',
})
export class ZoomService {
  private zoomInitialized = false;

  zmmtg: WritableSignal<HTMLElement | null> = signal(null);

  event: WritableSignal<JoinEvent | null> = signal(null);
  name: WritableSignal<string | null> = signal(null);
  email: WritableSignal<string | null> = signal(null);
  id: WritableSignal<number | string | null> = signal(null);
  tk: WritableSignal<string | null> = signal(null);

  loading: WritableSignal<boolean> = signal(false);

  savedRoute = ['/live/', '/my-activity/details/'];

  constructor(
    private ngZone: NgZone,
    private bookingEventService: BookingEventService,
    private router: Router
  ) {
    if (localStorage.getItem(zoomStart)) {
      this.loading.set(true);
    }
  }

  startMeeting(event: JoinEvent, name: string, email: string, id: number | string): void {
    if (event.registrantToken) {
      localStorage.removeItem(zoomStart);
    }

    this.email.set(email);
    this.name.set(name);
    this.event.set(event);
    this.id.set(id);

    ZoomMtg.preLoadWasm();
    ZoomMtg.prepareWebSDK();

    this.zmmtg.set(document.getElementById('zmmtg-root'));

    const zmmtg = this.zmmtg();

    zmmtg!.style.display = 'block';
    zmmtg!.style.zIndex = '99999';

    this.ngZone.runOutsideAngular(() => {
      ZoomMtg.init({
        leaveUrl: `${location.href}?`,
        patchJsMedia: true,
        leaveOnPageUnload: true,
        success: () => {
          this.loading.set(false);
          this.zoomInitialized = true;
          this.joinZoom();
        },
        error: (error: null | string) => {
          console.log(error);
          this.closeZoom();
        },
      });
    });
  }

  joinZoom(): void {
    ZoomMtg.join({
      signature: this.event()!.signature,
      sdkKey: this.event()!.sdkKey,
      meetingNumber: this.event()!.meetingId,
      passWord: this.event()!.password,
      userName: this.name()!,
      userEmail: this.email()!,
      tk: this.event()?.registrantToken || '',
      zak: this.event()!.zakToken,
      success: (success: null | string) => {
        console.log('join zoom', success);
      },
      error: (error: null | string) => {
        console.log('err zoom', error);
        this.closeZoom();
      },
    });

    this.onChangeZoomContainer();
  }

  onChangeZoomContainer(): void {
    const zoomContainer = document.getElementById('zmmtg-root');

    if (!zoomContainer) return;

    const observer = new MutationObserver(mutations => {
      mutations.forEach(() => {
        const manualZoomUI = zoomContainer.querySelector('.manual-success-title');

        if (manualZoomUI) {
          this.loading.set(true);
          const id = this.id();
          if (!id) return;
          this.bookingEventService.getZoomToken(id).subscribe({
            next: () => {
              localStorage.setItem(zoomStart, 'zoomStart');
              this.closeZoom();
            },
            error: () => {
              console.log('err');
              this.closeZoom();
            },
          });
        }
      });
    });

    observer.observe(zoomContainer, {
      childList: true,
      subtree: true,
    });
  }

  checkedSavedRouter(): boolean {
    return this.savedRoute.some(str => this.router.url.includes(str));
  }

  closeZoom(): void {
    if (this.zoomInitialized) {
      ZoomMtg.leaveMeeting({
        confirm: true,
        success: () => console.log('Meeting closed'),
        error: () => console.log('Leave error'),
      });
    }
    this.zoomInitialized = false;
  }
}
